<template>
  <form>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>shopping_basket</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;Alta de Consulta para Comercios
            {{ modalidadAltaId == 1 ? "Con Cupo" : "Sin Cupo" }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-select
            v-if="$store.state.debugModeOn"
            dense
            :items="listModalidadAltaConsulta"
            v-model="modalidadAltaId"
            item-text="descripcion"
            item-value="id"
            label="Modo Test"
            :disabled="!editMode"
          ></v-select>
          <v-spacer></v-spacer>

          <v-tooltip bottom v-if="action">
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <v-row>
            <v-col cols="8">
              <v-row v-if="selectedCanalVenta && selectedEmpresa">
                <v-col>
                  <v-card dark color="purple">
                    <v-card-text>
                      <div>
                        Solicitud para
                        <v-chip :color="selectedEmpresa.color">
                          {{ selectedEmpresa.nombre }}
                        </v-chip>
                        , en {{ selectedCanalVenta.nombre }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="infoCrediticia">
                <v-col>
                  <v-card dark color="green darken-3">
                    <v-card-text>
                      <div>{{ infoPersona }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="infoCrediticia && false">
                <v-col>
                  <v-card dark color="blue ligthten-3">
                    <v-card-text>
                      <div>{{ infoEmpleo }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  model.consultaCredito &&
                  model.consultaCredito.estado != '' &&
                  false
                "
              >
                <v-col>
                  <v-card dark color="orange ligthten-1">
                    <v-card-text>
                      <div>{{ infoconsultaCredito }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="!model.consultaCredito.resultadoTomadoDeAnalista && false"
            >
              <app-info-consulta-motor-siisa
                :consultaCredito="model.consultaCredito"
                v-if="motorSiisaActivo"
              ></app-info-consulta-motor-siisa>
            </v-col>
            <v-col v-if="model.consultaCredito.resultadoTomadoDeAnalista">
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title class="title">
                      Resultado de Analista
                    </v-card-title>

                    <v-card-text>
                      <v-row class="caption">
                        Tope Cuota: $ {{ model.consultaCredito.cupo }} / Tope
                        Producto: $ {{ model.consultaCredito.topeProducto }}
                      </v-row>
                      <v-divider></v-divider>

                      <!-- <v-row class="caption d-flex align-center">
                          ID Consulta: {{model.consultaCredito.respuestaMotorId}}
                      </v-row> -->
                      <v-divider></v-divider>
                      <v-row class="pa-2">
                        <v-chip
                          :color="colorEstado"
                          class="caption align-right"
                        >
                          {{ model.consultaCredito.estado }}</v-chip
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>

        <div class="text-xs-center">
          <v-progress-linear
            v-show="loadingProgress"
            indeterminate
          ></v-progress-linear>
        </div>

        <v-card-text>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1" color="green"
                >Datos del Solicitante</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2" color="orange"
                >Carga Completa</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3" color="orange"
                >Datos Finales</v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <v-layout wrap>
                <v-flex>
                  <!-- PASO 1 -->
                  <v-stepper-content step="1">
                    <ValidationObserver ref="paso1">
                      <v-card class="mb-5">
                        <v-container fluid>
                          <v-row dense>
                            <v-col cols="12" md="6" lg="4">
                              <v-autocomplete
                                disabled
                                v-model="model.empresaId"
                                :items="listEmpresas"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="Nueva Solicitud para la Empresa"
                                :menu-props="{
                                  minWidth: '200',
                                }"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" lg="4">
                              <v-autocomplete
                                disabled
                                v-model="model.canalVentaId"
                                :items="listCanalesVenta"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="a través del Canal de Venta"
                                :menu-props="{
                                  minWidth: '200',
                                }"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col cols="12" md="6" lg="4">
                              <v-autocomplete
                                v-model="model.productoId"
                                :items="listProductosDisponibles"
                                @change="selectedProductoChanged"
                                autocomplete="disabled"
                                item-text="productoDescripcion"
                                item-value="productoId"
                                label="¿Qué Producto va a solicitar?"
                                :menu-props="{
                                  minWidth: '200',
                                }"
                              ></v-autocomplete>
                              <v-chip
                                v-if="
                                  hayProductosNoDisponibles &&
                                  $store.state.debugModeOn
                                "
                                color="red"
                                text-color="white"
                                @click="showProductosNoDisponibles = true"
                                >Hay Productos no disponibles</v-chip
                              >
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col cols="12">
                              <h3>Ingrese los datos del Solicitante</h3>
                            </v-col>
                          </v-row>

                          <v-row align="center" dense>
                            <v-col cols="12" md="3" lg="2">
                              <v-radio-group v-model="ingresoPor">
                                <v-radio
                                  label="Documento"
                                  class="caption"
                                  key="documento"
                                  value="documento"
                                ></v-radio>
                                <v-radio
                                  label="Cuil"
                                  class="caption"
                                  key="cuil"
                                  value="cuil"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                              lg="2"
                              v-if="ingresoPor == 'documento'"
                            >
                              <v-text-field
                                label="Documento"
                                v-model="model.documento"
                                append-icon="search"
                                @click:append="
                                  buscarPersonaPorDocumento(model.documento)
                                "
                                autocomplete="disabled"
                                v-validate="'required'"
                                data-vv-name="documento"
                              ></v-text-field>
                            </v-col>
                            <!-- <v-col
                              cols="12"
                              md="4"
                              lg="2"
                              v-if="ingresoPor == 'documento'"
                            >
                              <v-autocomplete
                                v-model="model.personaDto.tipoSexoId"
                                :items="listSexos"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Sexo"
                                :menu-props="{ minWidth: '200' }"
                              ></v-autocomplete>
                            </v-col> -->
                            <v-col
                              cols="12"
                              md="3"
                              lg="2"
                              v-if="ingresoPor == 'cuil'"
                            >
                              <v-text-field
                                label="CUIL"
                                v-model="model.cui"
                                append-icon="search"
                                @click:append="
                                  buscarPersonaPorDocumento(model.cui)
                                "
                                v-validate="'required'"
                                data-vv-name="cuil"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" lg="2">
                              <v-chip
                                color="green"
                                text-color="white"
                                v-if="
                                  infoCrediticia != null &&
                                  infoCrediticia.tipoCalificacionId == 1
                                "
                                >{{
                                  infoCrediticia.tipoCalificacionDescripcion
                                }}</v-chip
                              >
                              <v-chip
                                color="orange"
                                text-color="white"
                                v-if="
                                  infoCrediticia != null &&
                                  infoCrediticia.tipoCalificacionId > 1
                                "
                                >{{
                                  infoCrediticia.tipoCalificacionDescripcion
                                }}</v-chip
                              >
                            </v-col>
                            <v-col cols="12" md="6" lg="6">
                              <v-chip
                                color="blue"
                                text-color="white"
                                v-if="
                                  tieneConsultasAprobadas &&
                                  this.model.consultaId
                                "
                                @click="showConsultasAprobadas = true"
                                >Hay Consultas con Cupo para esta
                                Persona</v-chip
                              >
                              <v-chip
                                color="blue"
                                text-color="white"
                                v-if="
                                  tieneConsultasAprobadas &&
                                  !this.model.consultaId
                                "
                                >Hay Consultas con Cupo para esta Persona. Puede
                                retomarlas desde la Bandeja de Consultas</v-chip
                              >
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="nombre"
                                v-if="motorSiisaActivo && false"
                              >
                                <v-text-field
                                  type="text"
                                  label="Nombre"
                                  v-model="model.personaDto.nombre"
                                  autocomplete="nope"
                                  hint="Puede dejar el Nombre vacío, se intentará recuperar desde el motor"
                                  persistent-hint
                                  data-vv-name="nombre"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                  :disabled="!canEditNombre"
                                ></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider
                                name="nombre"
                                rules="required"
                                v-if="!motorSiisaActivo && false"
                              >
                                <v-text-field
                                  type="text"
                                  label="Nombre"
                                  v-model="model.personaDto.nombre"
                                  autocomplete="nope"
                                  data-vv-name="nombre"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                  :disabled="!canEditNombre"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="apellido"
                                v-if="motorSiisaActivo && false"
                              >
                                <v-text-field
                                  label="Apellido"
                                  v-model="model.personaDto.apellido"
                                  autocomplete="nope"
                                  hint="Puede dejar el Apellido vacío, se intentará recuperar desde el motor"
                                  persistent-hint
                                  data-vv-name="apellido"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                  :disabled="!canEditNombre"
                                ></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider
                                name="apellido"
                                rules="required"
                                v-if="!motorSiisaActivo"
                              >
                                <v-text-field
                                  label="Apellido"
                                  v-model="model.personaDto.apellido"
                                  autocomplete="nope"
                                  data-vv-name="apellido"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                  :disabled="!canEditNombre"
                                  v-if="false"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="ingreso mensual"
                                rules="required|decimal:2|min_value:1000"
                                v-if="modalidadAltaId == 1 && false"
                              >
                                <v-text-field
                                  label="Ingreso Neto Mensual"
                                  v-model="model.personaDto.empleo.ingresoNeto"
                                  data-vv-name="ingreso mensual"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col cols="12" md="4" lg="4">
                              <ValidationProvider name="entidadFinanciera">
                                <v-autocomplete
                                  v-model="model.entidadFinancieraId"
                                  :items="listEntidadesFinancieras"
                                  clearable
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Banco"
                                  :menu-props="{ minWidth: '200' }"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                  :disabled="model.sinBanco"
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="movimientos"
                                rules="required|decimal:2|min_value:0"
                                v-if="modalidadAltaId == 1 && false"
                              >
                                <v-text-field
                                  label="Movimientos"
                                  v-model="model.movimientos"
                                  data-vv-name="movimientos"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row dense v-if="false">
                            <v-container fluid>
                              <v-checkbox
                                v-model="showAgregarDocumentacion"
                                :disabled="user.esComer"
                                label="Adjuntar Documentación para Cupo"
                              ></v-checkbox>

                              <div>
                                <v-file-input
                                  v-model="archivosASubirDocumentacion"
                                  placeholder="Seleccione la Documentación"
                                  label="Archivos con la Documentación"
                                  chips
                                  multiple
                                  counter
                                  show-size
                                  prepend-icon="search"
                                >
                                </v-file-input>
                              </div>
                              <v-row
                                dense
                                align="center"
                                v-if="errorAlAgregarDocumentacion"
                              >
                                <v-col>
                                  <v-alert color="error" dense dark>
                                    Error al Adjuntar documentación para el Cupo
                                  </v-alert>
                                </v-col>
                                <v-col>
                                  <v-btn dark @click="uploadFiles"
                                    >Reintentar Carga</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-row>
                          <v-row>
                            <v-col cols="2">
                              <ValidationProvider name="celular">
                                <v-text-field
                                  v-model="celular"
                                  label="Celular"
                                  data-vv-name="celular"
                                  counter
                                >
                                  <template v-slot:append>
                                    <v-tooltip
                                      bottom
                                      v-if="!celularValidado && !validando"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          @click="validarTelefono"
                                          >help_outline</v-icon
                                        >
                                      </template>
                                      <span
                                        >Ingresar los 10 números del teléfono
                                        (sin el 15 ni el '0' delante del código
                                        de área) y presione para validar</span
                                      >
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="celularValidado">
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                          color="green"
                                          v-on="on"
                                          @click="validarTelefono"
                                          >check_circle_outline</v-icon
                                        >
                                      </template>
                                      <span>Formato Validado</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              v-if="
                                resultadoValidacion.esValido == false &&
                                resultadoValidacion.motivoNoValida
                              "
                            >
                              <v-chip class="caption" color="red" dark>{{
                                resultadoValidacion.motivoNoValida
                              }}</v-chip>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="consultarVisible"
                            color="primary"
                            @click="nextStep(1)"
                          >
                            Consultar
                          </v-btn>

                          <v-btn text @click="cancelar">Limpiar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </ValidationObserver>
                  </v-stepper-content>

                  <!-- PASO 2 (CARGA COMPLETA)-->
                  <v-stepper-content step="2">
                    <v-card class="mb-5">
                      <v-layout>
                        <v-flex xs12>
                          <v-card dark color="blue ligthten-3">
                            <v-card-text>
                              <div>{{ infoCredito }}</div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-container fluid>
                        <ValidationObserver ref="paso3">
                          <v-row>
                            <v-col cols="8">
                              <v-row>
                                <v-col md="6" lg="4">
                                  <v-autocomplete
                                    v-model="model.planId"
                                    :items="listPlanesDisponibles"
                                    @change="selectedPlanChanged"
                                    :disabled="user.esComer || user.esComercio"
                                    item-text="planNombre"
                                    item-value="planId"
                                    label="Planes Disponibles"
                                    :menu-props="{
                                      minWidth: '200',
                                    }"
                                  ></v-autocomplete>

                                  <v-chip
                                    v-if="
                                      hayPlanesNoDisponibles &&
                                      $store.state.debugModeOn
                                    "
                                    color="red"
                                    text-color="white"
                                    @click="showPlanesNoDisponibles = true"
                                    >Hay Planes no disponibles</v-chip
                                  >
                                </v-col>
                              </v-row>

                              <!-- <v-row>
                              <v-col cols="3">
                                <v-switch v-model="model.modificaOferta" label="Modificar Oferta"></v-switch>
                              </v-col>
                              <v-col>
                                <v-text-field v-if="model.modificaOferta" label="Ingrese el motivo para la modificación" v-model="model.motivoModificacionOferta" ></v-text-field>
                              </v-col>
                            </v-row> -->

                              <v-row
                                v-if="
                                  model.consultaCredito.cupo > 0 ||
                                  model.consultaCredito.topeProducto > 0
                                "
                              >
                                <v-col>
                                  <v-chip label color="warning"
                                    >Recuerde que la Cuota Máxima es de
                                    {{
                                      model.consultaCredito.cupo | currency
                                    }}</v-chip
                                  >
                                  <v-chip
                                    label
                                    color="pink"
                                    dark
                                    v-if="
                                      model.consultaCredito.topeProducto > 0
                                    "
                                    >y un Monto Máximo de
                                    {{
                                      model.consultaCredito.topeProducto
                                        | currency
                                    }}</v-chip
                                  >
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col>
                                  <!-- <v-radio-group row v-model="ingresoPorMonto" :disabled="!model.modificaOferta"> -->
                                  <v-radio-group row v-model="ingresoPorMonto">
                                    <v-radio
                                      label="Ingresar Monto"
                                      value="true"
                                    ></v-radio>
                                    <v-radio
                                      label="Ingresar Cuota Máxima"
                                      value="false"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col md="4" lg="3">
                                  <v-text-field
                                    label="Solicita"
                                    v-model="capitalIngresado"
                                    v-show="ingresoPorMonto == 'true'"
                                    persistent-hint
                                    :hint="
                                      model.consultaCredito.topeProducto
                                        ? 'Ingresar como Máximo $' +
                                          model.consultaCredito.topeProducto
                                        : ''
                                    "
                                  ></v-text-field>
                                  <v-text-field
                                    label="Cuota Máxima"
                                    persistent-hint
                                    :hint="
                                      model.consultaCredito.cupo
                                        ? 'Ingresar como Máximo $' +
                                          model.consultaCredito.cupo
                                        : ''
                                    "
                                    v-model="importeCuotaMaximaIngresado"
                                    v-show="ingresoPorMonto == 'false'"
                                  ></v-text-field>
                                </v-col>
                                <v-col>
                                  <v-btn
                                    color="blue-grey"
                                    outlined
                                    @click="calcularOpcionesPlan"
                                  >
                                    Recalcular
                                  </v-btn>
                                </v-col>
                              </v-row>

                              <v-row v-if="false">
                                <v-col>
                                  <v-text-field
                                    :disabled="model.montoRenovacionAsignado"
                                    label="Renovación"
                                    v-model="model.montoRenovacion"
                                  ></v-text-field>
                                </v-col>

                                <!-- <v-col v-if="selectedCanalVenta && selectedCanalVenta.nombre.includes('AMTAE')">
                                <v-text-field  :disabled="model.montoRetencionAsignado" label="Retención" v-model="model.montoRetencion"></v-text-field>
                              </v-col> -->
                              </v-row>
                            </v-col>

                            <v-col>
                              <v-layout column>
                                <v-flex>
                                  <v-card>
                                    <v-card-title>
                                      <h6 v-show="ingresoPorMonto == 'true'">
                                        Puede Solicitar $
                                        {{ capitalIngresado }} en
                                      </h6>
                                      <h6 v-show="ingresoPorMonto == 'false'">
                                        Puede Solicitar hasta
                                      </h6>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-radio-group row v-model="indiceOferta">
                                        <v-radio
                                          v-for="item in opcionesPlanes"
                                          @change="setCuotaSeleciconada(item)"
                                          :key="item.indice"
                                          :label="item.oferta"
                                          :value="item.indice"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-card-text>
                                    <v-card-actions>
                                      <h6 v-show="ingresoPorMonto == 'false'">
                                        * si quiere un monto en particular,
                                        seleccione Ingreso por Monto
                                      </h6>
                                    </v-card-actions>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-container>
                      <v-snackbar
                        v-model="hayErroresPolitica"
                        color="red"
                        bottom
                        :timeout="60000"
                      >
                        {{ errorPolitica }}
                        <v-btn dark text @click="hayErroresPolitica = false">
                          Cerrar
                        </v-btn>
                      </v-snackbar>
                    </v-card>

                    <v-card-actions>
                      <!-- <v-btn
                          color="primary"
                          @click="step = step-1"
                        >
                          Volver
                        </v-btn> -->

                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click="validarMontoCuotas"
                        :disabled="!puedeContinuarPaso3"
                      >
                        Siguiente Paso
                      </v-btn>

                      <v-btn text @click="cancelar">Cancelar</v-btn>
                    </v-card-actions>
                  </v-stepper-content>

                  <!-- PASO 4 -->
                  <v-stepper-content step="3">
                    <v-card class="mb-5">
                      <v-layout>
                        <v-flex xs12>
                          <v-card dark color="blue ligthten-3">
                            <v-card-text>
                              <div>{{ infoCredito }}</div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-container fluid>
                        <v-layout>
                          <v-flex xs8>
                            <v-row v-if="model.calificacionPersonaId <= 1">
                              <v-col cols="6">
                                <h3>
                                  El solicitante es Nuevo, por lo que debe
                                  completar el Legajo del mismo
                                </h3>
                              </v-col>
                              <v-col>
                                <v-btn outlined @click="showLegajo = true"
                                  >Completar Solicitud</v-btn
                                >
                              </v-col>
                              <v-col>
                                <v-icon v-if="legajoCheck" color="green"
                                  >done_outline</v-icon
                                >
                              </v-col>
                            </v-row>

                            <v-row v-if="model.calificacionPersonaId > 1">
                              <v-col cols="6">
                                <h3>
                                  El solicitante ya es Cliente, revise el legajo
                                  y actualice los datos que sean necesarios
                                </h3>
                              </v-col>
                              <v-col>
                                <v-btn outlined @click="showLegajo = true"
                                  >Completar Solicitud</v-btn
                                >
                              </v-col>
                              <v-col>
                                <v-icon v-if="legajoCheck" color="green"
                                  >done_outline</v-icon
                                >
                              </v-col>
                            </v-row>

                            <!-- DATOS DEBITO CBU -->
                            <div>
                              <v-row>
                                <v-col>
                                  <h3>Datos de la Cuenta Bancaria</h3>
                                </v-col>
                              </v-row>

                              <v-row no-gutters>
                                <v-col cols="6">
                                  <v-switch
                                    v-model="model.solicitaDebito"
                                    label="Solicita Débito en Cuenta "
                                  >
                                  </v-switch>
                                </v-col>
                              </v-row>
                              <!-- Si solicita débito o si el medio de pago es por transferencia habilito-->
                              <v-row
                                v-if="
                                  model.solicitaDebito ||
                                  model.tipoMedioPagoId == 2
                                "
                                no-gutters
                              >
                                <v-col cols="10" v-if="cuentaDebitoAnses">
                                  <v-row>
                                    <v-alert color="primary" dark dense>
                                      <v-col>
                                        Débito Sobre cuenta CBU :
                                        {{ model.cuentaDebito.cbu }}
                                      </v-col>
                                      <v-col cols="2">
                                        <v-autocomplete
                                          v-model="
                                            model.cuentaDebito.diaCobroId
                                          "
                                          :items="listDiasCobro"
                                          item-text="descripcion"
                                          item-value="id"
                                          label="Día de Cobro"
                                          :disabled="esPasivoAnses"
                                          :menu-props="{
                                            minWidth: '200',
                                          }"
                                        ></v-autocomplete>
                                      </v-col>
                                    </v-alert>
                                    <v-chip small dense dark color="green"
                                      >Si quiere ingresar un CBU diferente,
                                      marque la opción "Agregar nueva Cuenta"
                                      más abajo</v-chip
                                    >
                                  </v-row>
                                </v-col>
                                <v-col cols="10">
                                  <app-datos-debito-credito
                                    :standAloneMode="false"
                                    :personaId="model.personaId"
                                    :creditoId="model.consultaCredito.id"
                                    :situacionLaboralActividadId="
                                      situacionLaboralActividadEmpleo
                                    "
                                    :documento="model.personaDto.documento"
                                    :subSituacionLaboralId="
                                      subSituacionLaboralEmpleo
                                    "
                                    :cuentaSeleccionada="model.cuentaDebito"
                                  ></app-datos-debito-credito>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Pago por tarjeta  -->

                            <!-- <div
                              v-if="
                                model.consultaCredito.medioCobro ==
                                  'TARJETA DE DEBITO' ||
                                this.productoDescripcion
                                  .toLowerCase()
                                  .includes('tarjeta debito')
                              "
                            > -->
                            <div>
                              <v-row>
                                <v-col>
                                  <h3>Datos de la Tarjeta de Débito</h3>
                                </v-col>
                              </v-row>

                              <v-row no-gutters>
                                <v-col cols="6">
                                  <v-switch
                                    v-model="model.solicitaDebitoATarjeta"
                                    label="Completar Datos"
                                  >
                                  </v-switch>
                                </v-col>
                              </v-row>

                              <v-row
                                v-if="model.solicitaDebitoATarjeta"
                                no-gutters
                              >
                                <v-col cols="10">
                                  <v-radio-group
                                    row
                                    v-model="model.tarjetaDebito.activa"
                                    :disabled="
                                      (model.consultaCredito.medioCobro ==
                                        'TARJETA DE DEBITO' ||
                                        this.productoDescripcion
                                          .toLowerCase()
                                          .includes('tarjeta debito')) &&
                                      !checkCanAccess(
                                        'ap-puede-activar-tarjeta',
                                      )
                                    "
                                  >
                                    <v-radio
                                      label="Débito Activo"
                                      :value="true"
                                    ></v-radio>
                                    <v-radio
                                      label="Inactivo"
                                      :value="false"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>

                              <v-row
                                v-if="model.solicitaDebitoATarjeta"
                                no-gutters
                              >
                                <v-col cols="10">
                                  <app-datos-tarjeta
                                    v-on:token-generado="
                                      updateDatosTarjeta($event)
                                    "
                                    v-on:datos-actualizados="
                                      updateDatosTarjeta($event)
                                    "
                                    :standAloneMode="false"
                                    :empresaId="model.empresaId"
                                    :personaId="model.personaId"
                                    :creditoId="model.consultaCredito.id"
                                    :tarjetaSeleccionada="model.tarjetaDebito"
                                    :cuotasPendientesCredito="model.cuotas"
                                    :modoInmediato="true"
                                  ></app-datos-tarjeta>
                                </v-col>
                              </v-row>
                            </div>

                            <v-row>
                              <v-col>
                                <h3>
                                  Para finalizar, especifique los siguientes
                                  datos
                                </h3>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <ValidationProvider
                                  name="medio de pago"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    v-model="model.tipoMedioPagoId"
                                    :items="listMediosPago"
                                    :disabled="puedeModificarMedioPago"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="El desembolso del crédito será mediante"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="medio de pago"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>

                              <v-col v-if="model.tipoMedioPagoId == 5">
                                <ValidationProvider
                                  name="comercio"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    v-model="model.pagoAGrupoComercialId"
                                    :items="listGruposComerciales"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Al Comerciante"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="comercio"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                    disabled
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>

                              <v-col v-if="false">
                                <ValidationProvider
                                  name="forma de llegada"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    v-model="model.tipoFormaLlegadaId"
                                    :items="listFormasLlegada"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Indique cómo llegó el solicitante"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="forma de llegada"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col v-if="false">
                                <ValidationProvider
                                  name="motivo de la solicitud"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    v-model="model.tipoMotivoSolicitudId"
                                    :items="listDestinosCredito"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Indique cuál es el destino del crédito"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="motivo de la solicitud"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row
                              v-if="
                                tipoProductoDescripcion
                                  .toUpperCase()
                                  .includes('DIRIGIDO CONSUMO')
                              "
                            >
                              <v-col cols="12" lg="6">
                                <ValidationProvider
                                  name="producto a entregar"
                                  rules="required"
                                >
                                  <v-text-field
                                    label="Producto A Entregar"
                                    v-model="model.productoAEntregar"
                                    v-validate="'required'"
                                    data-vv-name="productoAEntregar"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-col cols="2">
                              <v-checkbox
                                v-model="esCelular"
                                label="Es Celular"
                              ></v-checkbox>
                            </v-col>

                            <v-row no-gutters v-if="esCelular">
                              <v-col>
                                <v-autocomplete
                                  v-model="model.modelo"
                                  :items="listModelos"
                                  :disabled="false"
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Modelo"
                                  placeholder="Modelo"
                                  :menu-props="{
                                    minWidth: '200',
                                  }"
                                ></v-autocomplete>
                              </v-col>

                              <v-col>
                                <v-text-field
                                  v-model="model.imei"
                                  label="IMEI"
                                  :disabled="
                                    !checkCanAccess(
                                      'ap-puede-modificar-productoentregado',
                                    )
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-flex>

                          <v-flex xs4 v-if="step == 3">
                            <v-container>
                              <v-layout wrap>
                                <v-flex>
                                  <v-text-field
                                    v-model="model.politicaComercialId"
                                    label="PoliticaId"
                                    v-if="$store.state.debugModeOn"
                                  ></v-text-field>
                                  <app-validador-politica-comercial
                                    v-if="model.politicaComercialId > 0"
                                    :politica="this.politicaComercial"
                                    :ParametrosAValidar="model"
                                    v-bind:PoliticaAprobada.sync="
                                      politicaAprobada
                                    "
                                    v-bind:ErroresPolitica.sync="errorPolitica"
                                    v-bind:AutorizadoPorExcepcion.sync="
                                      model.seAutorizoPorExcepcion
                                    "
                                    v-bind:AutorizadoPorUsuario.sync="
                                      model.usuarioQueAutorizo
                                    "
                                    v-bind:AutorizadoPorMotivo.sync="
                                      model.motivoAutorizacion
                                    "
                                  ></app-validador-politica-comercial>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>

                    <v-card-actions>
                      <v-btn color="primary" @click="step = step - 1">
                        Volver
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="accent"
                            @click="confirmarAlta(true)"
                          >
                            Dejar Pendiente
                          </v-btn>
                        </template>
                        <span
                          >Se guardarán los datos cargados, y la consulta
                          quedará en estado Consulta Pendiente</span
                        >
                      </v-tooltip>

                      <v-btn color="primary" @click="confirmarAlta(false)">
                        Confirmar Operación
                      </v-btn>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" text @click="cancelar">
                            Cancelar
                          </v-btn>
                        </template>
                        <span
                          >Se cancela la carga, se perderán los datos
                          cargados</span
                        >
                      </v-tooltip>
                    </v-card-actions>
                  </v-stepper-content>
                </v-flex>
              </v-layout>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
      <app-loading :loading="loading"></app-loading>

      <!-- productos no disponibles -->
      <v-dialog v-model="showProductosNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Productos No disponibles</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listProductos.filter((p) => !p.estaDisponible)"
                  :key="item.productoId"
                >
                  <template>
                    <h5>{{ item.productoDescripcion }}:</h5>
                    <div class="caption">{{ item.motivoNoDisponible }}</div>
                  </template>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- planes no disponibles -->
      <v-dialog v-model="showPlanesNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Planes No disponibles</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listPlanes.filter((p) => !p.estaDisponible)"
                  :key="item.planId"
                >
                  <template>
                    <h5>{{ item.planNombre }}:</h5>
                    <div class="caption">{{ item.motivoNoDisponible }}</div>
                  </template>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- legajo  -->
      <v-dialog v-model="showLegajo" width="1000" persistent>
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Legajo de la Persona</v-card-title>
          <v-card-text>
            <legajo-persona
              :value="model.personaDto"
              :visible="showLegajo"
              :legajoGuardado="legajoGuardado"
              :mailObligatorio="productoDescripcion.includes('COMERCIO')"
            ></legajo-persona>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- consultas aprobadas con cupo -->
      <v-dialog v-model="showConsultasAprobadas" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline"
            >Consultas Aprobadas para la Persona</v-card-title
          >
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listConsultasAprobadas"
                  :key="item.Id"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >Cupo Aprobado: $ {{ item.cupo }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      ><div class="caption">Producto: {{ item.producto }}</div>
                      <div class="caption">
                        Fecha: {{ item.fechaIngreso | formatDate }}
                      </div>
                      <div class="caption">
                        Alta por: {{ item.usuarioAlta }}
                      </div></v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn color="green" dark @click="retomarConsulta(item)">
                      Retomar
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- resultado consulta -->
      <v-dialog v-model="showResultadoConsulta" width="600" persistent>
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline"></v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-row dense>
                <v-col>
                  La consulta fue registrada, con resultado:
                  <span class="headline">{{
                    model.consultaCredito.estado
                      .replace("CON CUPO", "")
                      .replace("SIN CUPO", "")
                  }}</span>
                </v-col>
                <v-col>
                  {{ model.consultaCredito.resultado }}
                </v-col>
              </v-row>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="
                showResultadoConsulta = false;
                nuevoProspecto();
              "
              color="success"
              >Cargar Prospecto</v-btn
            >

            <v-spacer></v-spacer>
            <v-btn
              @click="
                showResultadoConsulta = false;
                continuarACargaCompleta();
              "
              color="success"
              v-if="model.consultaCredito.estado == 'APROBADO CON CUPO'"
              >Continuar</v-btn
            >
            <v-btn @click="showResultadoConsulta = false" color="success" v-else
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- save progress consulta -->
      <v-dialog v-model="showSaveProgressConsulta" width="500">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="title"
            >Realizando Consulta, aguarde unos instantes...</v-card-title
          >
          <v-card-text>
            <v-layout column>
              <v-row dense>
                <v-col> Registrando Operación... </v-col>
                <v-col>
                  <v-progress-circular
                    v-if="saving"
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                  <v-icon large v-else>done</v-icon>
                </v-col>
              </v-row>
              <v-row dense v-if="showAgregarDocumentacion">
                <v-col> Subiendo archivos... </v-col>
                <v-col>
                  <v-progress-circular
                    v-if="uploading"
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                  <v-icon large v-else>done</v-icon>
                </v-col>
              </v-row>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- save progress alta -->
      <v-dialog v-model="showSaveProgressAlta" width="400">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Guardando Consulta...</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-row>
                <v-col> Registrando Operación... </v-col>
                <v-col>
                  <v-progress-circular
                    v-if="saving"
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                  <v-icon large v-else>done</v-icon>
                </v-col>
              </v-row>
              <v-row v-if="archivosASubirDocumentacion.length > 0">
                <v-col> Subiendo archivos... </v-col>
                <v-col>
                  <v-progress-circular
                    v-if="uploading"
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                  <v-icon large v-else>done</v-icon>
                </v-col>
              </v-row>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- resultado validacion identidad -->
      <v-dialog v-model="showResultadoValidacionIdentidad" width="700">
        <v-card dense>
          <v-card-title class="h6">
            Se encontraron las siguientes pesonas con el Documento ingresado
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item
                v-for="(item, i) in resultadoValidacionIdentidad"
                :key="i"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                  <v-list-item-content>{{ item.cuil }}</v-list-item-content>
                </v-list-item-content>
                <v-list-item-content>
                  <v-btn
                    dark
                    small
                    color="green"
                    @click="
                      ingresoPor = 'cuil';
                      model.cui = item.cuil;
                      model.personaDto.nombre = item.nombre;
                      showResultadoValidacionIdentidad = false;
                      buscarPersonaPorDocumento(model.cui);
                    "
                    >Continuar Carga con esta Persona</v-btn
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- save results -->
      <v-dialog v-model="showSaveResults" width="700">
        <v-card dense>
          <v-card-title class="headline">
            <v-icon color="green">thumb_up</v-icon> El proceso se completó
            correctamente
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="(item, i) in saveResults.acciones" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-if="item.includes('Link Güeno')">
                    <app-link-gueno
                      v-if="checkCanAccess('ap-mostrar-link-gueno')"
                      :info="item"
                      :solicitudId="model.consultaId"
                    ></app-link-gueno>
                  </v-list-item-title>
                  <v-list-item-title v-else-if="item.includes('Link Firma')">
                    <app-link-gueno
                      v-if="checkCanAccess('ap-mostrar-link-gueno')"
                      :info="item"
                      :solicitudId="model.consultaId"
                    ></app-link-gueno>
                  </v-list-item-title>
                  <v-list-item-title
                    v-else-if="item.includes('Link Digiventures')"
                  >
                    <app-link-digiventures
                      v-if="checkCanAccess('ap-mostrar-link-gueno')"
                      :info="item"
                      :solicitudId="model.consultaId"
                    ></app-link-digiventures>
                  </v-list-item-title>
                  <v-list-item-title
                    v-else-if="item.includes('Link de Carga Rápida')"
                  >
                    <app-link-carga-rapida-comer
                      :info="item"
                    ></app-link-carga-rapida-comer>
                  </v-list-item-title>
                  <v-list-item-title v-else-if="item.includes('Link CardCred')">
                    <app-link-cardcred
                      :info="item"
                      :solicitudId="model.consultaId"
                    ></app-link-cardcred>
                  </v-list-item-title>
                  <v-list-item-title v-else v-text="item"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-container fluid>
                  <div>
                    <v-file-input
                      v-model="archivosASubirLegajo"
                      placeholder="Seleccione el archivo"
                      label="Adjuntar imágenes de legajo manual en caso de corresponder"
                      chips
                      multiple
                      counter
                      show-size
                      prepend-icon="search"
                    >
                    </v-file-input>

                    <v-btn dark @click="uploadFilesLegajo(true)"
                      >Enviar Documentación</v-btn
                    >
                  </div>
                </v-container>
              </v-row>

              <v-row>
                <v-btn
                  @click="(showSaveResults = false), cerrarSaveResults()"
                  color="green"
                  >Cerrar</v-btn
                >
                <v-spacer></v-spacer>
                <app-impresion-formulario
                  :creditoId="impresionCreditoId"
                  :empresaId="impresionCreditoEmpresaId"
                  :productoDescripcion="productoDescripcion"
                ></app-impresion-formulario>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- <v-btn @click="test">TEST GUENO</v-btn> -->
    </v-container>
    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Ingreso Por Monto: {{ ingresoPorMonto }}
      <p></p>
      Monto: {{ capitalIngresado }}
      <p></p>
      Cta Maxima: {{ importeCuotaMaximaIngresado }}
      <p></p>
      Errores Política: {{ errorPolitica }} Politica Aprobada:
      {{ politicaAprobada }}

      Model: {{ model }}
      <p></p>
    </template>
  </form>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import legajoVirtualService from "@/services/legajoVirtual.service";

import LegajoPersona from "./DatosLegajoSimple";

import { mapGetters, mapMutations, mapActions } from "vuex";
import { format } from "date-fns";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    "legajo-persona": LegajoPersona,
  },
  props: ["retomarConsultaId"],
  data() {
    return {
      modalidadAltaId: 1,
      step: 0,
      loading: false,
      loadingProgress: false, // Lo uso para la progress bar
      editMode: true,
      showProductosNoDisponibles: false,
      showPlanesNoDisponibles: false,
      showLegajo: false,
      model: {
        personaId: null,
        cuentaDebito: {},
        tarjetaDebito: {},
        solicitaDebito: false,
        tipoFormaLlegadaId: 1,
        tipoMotivoSolicitudId: 1,
        tipoMedioPagoId: 1,
        planId: 0,
        productoId: 0,
        solicitaDebitoATarjeta: false,
      },
      selectedPersonaBusqueda: null,
      infoCrediticia: null,
      importe: 0,
      listSituacionesLaborales: [],
      listEmpresas: [],
      listCanalesVentaHabilitados: [],
      listProductos: [],
      listProductosDisponibles: [],
      listPlanes: [],
      listPlanesDisponibles: [],
      listSexos: [],
      listMediosPago: [],
      listDiasCobro: [],
      listFormasLlegada: [],
      listDestinosCredito: [],
      listEntidadesFinancieras: [],
      listModalidadAltaConsulta: [],
      listGruposComerciales: [],
      ingresoPorMonto: "true",
      politicaComercial: {},
      opcionesPlanes: [],
      cuotaSeleccionada: { cuotas: 0 },
      politicaAprobada: false,
      errorPolitica: "",
      hayErroresPolitica: false,
      legajoCheck: false,
      indiceOferta: 0,
      capitalIngresado: 0,
      importeCuotaMaximaIngresado: 0,
      showAgregarDocumentacion: false,
      errorAlAgregarDocumentacion: false,
      errorAlAgregarLegajo: false,
      showAgregarLegajo: false,
      archivosASubirDocumentacion: [],
      archivosASubirLegajo: [],
      archivosASubir: [],
      motorSiisaActivo: false,
      showConsultasAprobadas: false,
      showResultadoConsulta: false,

      listConsultasAprobadas: [],
      showSaveProgressConsulta: false,
      showSaveProgressAlta: false,
      saving: false,
      uploading: false,
      ingresoPor: "documento",
      consultarVisible: true,
      showSaveResults: false,
      saveResults: [],
      impresionCreditoId: null,
      impresionCreditoEmpresaId: null,
      productoDescripcion: "",
      canEditNombre: false,
      cuentaDebitoAnses: false,
      showResultadoValidacionIdentidad: false,
      resultadoValidacionIdentidad: [],
      celular: "",
      celularValidado: false,
      validando: false,
      resultadoValidacion: { esValido: true },
      esCelular: false,
    };
  },
  async created() {
    this.modalidadAltaId = this.user.modalidadAltaConsultaId;
    this.motorSiisaActivo =
      this.$store.state.parametrosGenerales.conexionMotorSiisa;

    this.clear();

    await this.loadCanalesVentaHabilitados();
    this.loadSituacionesLaborales();
    this.loadSexo();
    this.loadDiasCobro();
    this.loadMediosPago();
    this.loadFormasLlegada();
    this.loadDestinosCredito();
    this.loadEntidadesFinancieras();
    this.loadTiposModalidadesAltaConsulta();
    this.loadGruposComerciales();
    this.loadModelos();

    this.showAgregarDocumentacion = false; // this.user.esComer;

    if (this.retomarConsultaId) {
      await this.retomarConsultaCredito(this.retomarConsultaId);
    }
  },
  watch: {
    "model.canalVentaId": async function () {
      // cargo los productos disponibles
      await this.loadProductosDisponibles();
    },
    celular: function (item) {
      if (!this.resultadoValidacion.esValido) {
        this.celularValidado = false;
      }
      this.resultadoValidacion.esValido = false;
    },
    "model.productoId": async function () {
      console.log("Producto ");
      if (!this.model.productoId || this.model.productoId == 0) return;
      this.productoDescripcion = this.listProductos.find(
        (p) => p.productoId === this.model.productoId,
      ).productoDescripcion;
    },
    "model.planId": async function () {
      // si el plan tiene como medio de cobro Debito en Cuenta, pongo como predeterminado el tilde de solicita debito
      // y la forma de pago x transferencia
      var plan = this.listPlanesDisponibles.find(
        (i) => i.planId == this.model.planId,
      );

      if (!plan) return;

      if (plan.requiereDebitoEnCuenta) {
        this.model.solicitaDebito = true;
      } else {
        this.model.solicitaDebito = false;
      }

      if (plan.medioPagoId > 0) {
        this.model.tipoMedioPagoId = plan.medioPagoId;
      }

      await this.setPoliticaComercial();
      await this.calcularOpcionesPlan();
    },
    "model.tarjetaDebito.activa": function () {
      if (
        this.model.tarjetaDebito.activa &&
        (this.model.cuentaDebito.debitoATitular ||
          this.model.cuentaDebito.debitoAGarante)
      ) {
        this.alertWarning(
          "No puede activarse el Débito por Tarjeta ya que se ha seleccionado Débito en Cuenta. Por favor, verifique",
        );

        Vue.nextTick(() => {
          // esto es para esperar a que se renderice el componente nuevo
          Vue.set(this.model.tarjetaDebito, "activa", false);
        });
      }
    },
    "model.cuentaDebito.debitoATitular": function () {
      if (
        this.model.tarjetaDebito.activa &&
        this.model.cuentaDebito.debitoATitular
      ) {
        this.alertWarning(
          "No puede activarse el Débito en Cuenta ya que se ha seleccionado Débito por Tarjeta. Por favor, verifique",
        );

        // Vue.nextTick(() => { // esto es para esperar a que se renderice el componente nuevo
        //   Vue.set(this.model.cuentaDebito, 'debitoATitular', false);
        // });
      }
    },
    "model.cuentaDebito.debitoAGarante": function () {
      if (
        this.model.tarjetaDebito.activa &&
        this.model.cuentaDebito.debitoAGarante
      ) {
        this.alertWarning(
          "No puede activarse el Débito en Cuenta ya que se ha seleccionado Débito por Tarjeta. Por favor, verifique",
        );

        // Vue.nextTick(() => { // esto es para esperar a que se renderice el componente nuevo
        //   Vue.set(this.model.cuentaDebito, 'debitoAGarante', false);
        // });
      }
    },
    errorPolitica: function () {
      // cargo los productos disponibles
      this.hayErroresPolitica = this.errorPolitica != "";
      this.model.motivoSolicitudAutorizacion = this.errorPolitica;
    },
    ingresoPorMonto: function () {
      if (this.ingresoPorMonto == "true") {
        this.importeCuotaMaximaIngresado = 0;
      } else {
        this.capitalIngresado = 0;
      }
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, "YYYY-MM-DD");
    },
  },
  computed: {
    ...mapGetters([
      "user",
      "UiCustomUserSettings",
      "DebugModeOn",
      "getActionFromLink",
      "checkCanAccess",
      "ParametrosGenerales",
    ]),
    situacionLaboralActividadEmpleo() {
      return this.model.personaDto.empleo != null
        ? this.model.personaDto.empleo.situacionLaboralActividadId
        : null;
    },
    subSituacionLaboralEmpleo() {
      return this.model.personaDto.empleo != null
        ? this.model.personaDto.empleo.subSituacionLaboralId
        : null;
    },
    esPasivoAnses() {
      return (
        this.model.personaDto.empleo != null &&
        [41, 43, 44, 64].includes(
          Number(this.model.personaDto.empleo.situacionLaboralActividadId),
        )
      );
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    puedeModificarMedioCobro: function () {
      var plan = this.listPlanesDisponibles.find(
        (i) => i.planId == this.model.planId,
      );

      return plan != null && !plan.requiereDebitoEnCuenta;
    },
    puedeModificarMedioPago: function () {
      var plan = this.listPlanesDisponibles.find(
        (i) => i.planId == this.model.planId,
      );
      return plan != null && plan.medioPagoId > 0;
    },
    listCanalesVenta: function () {
      // devuelvo los canales de venta de la empresa seleccionada
      let canalesDisponibles = this.listCanalesVentaHabilitados.filter(
        (i) => i.empresaId == this.model.empresaId,
      );

      return canalesDisponibles;
    },
    selectedEmpresa: function () {
      if (this.model.empresaId && this.model.empresaId > 0)
        return this.listEmpresas.find((i) => i.id === this.model.empresaId);

      return null;
    },
    selectedCanalVenta: function () {
      if (this.model.canalVentaId && this.model.canalVentaId > 0)
        return this.listCanalesVentaHabilitados.find(
          (i) => i.id === this.model.canalVentaId,
        );

      return null;
    },
    edad: function () {
      if (!this.persona) return "-";

      var dob = this.$moment(this.model.fechaNacimiento);

      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970) + " años";
      }
      return "-";
    },
    infoPersona: function () {
      if (!this.infoCrediticia) return null;

      var dob = this.$moment(this.model.personaDto.fechaNacimiento);

      var edad = "";
      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        edad = Math.abs(ageDate.getUTCFullYear() - 1970) + " años";
      }

      var info =
        "Solicitante " +
        this.infoCrediticia.tipoCalificacionDescripcion +
        ": " +
        this.model.personaDto.nombre +
        " " +
        this.model.personaDto.apellido +
        ", " +
        this.infoCrediticia.documentoCompleto;
      return info;
    },
    infoEmpleo: function () {
      if (!this.infoCrediticia && !this.model.personaDto) return null;

      var info = "";
      if (!this.model.personaDto.empleo || this.model.personaDto.empleo == null)
        return "No tiene empleo cargado";

      //console.log('this.model.personaDto')
      //console.log(this.model.personaDto)
      switch (this.model.personaDto.tipoSituacionLaboralId) {
        case 0: // nuevo
          info = "Situación Laboral no especificada";
          break;
        case 1: // relación de dependencia
          if (this.model.personaDto.empleo.empleador == "")
            info = "No registra empleo ";
          else info = "Trabaja en " + this.model.personaDto.empleo.empleador;
          break;
        case 2: // autónomo
        case 3: // monotributista
        case 4: // jubi
          info =
            "Es " +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId,
            ).descripcion;
          break;
        case 5: // fuerzas
          info =
            "Pertenece a las " +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId,
            ).descripcion;
          break;
        case 6: // fuerzas
          info = "Realiza otras actividades ";
          break;
        default:
          info =
            "Es " +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId,
            ).descripcion;
          break;
      }

      if (this.model.personaDto.empleo.ingresoNeto > 0) {
        info =
          info +
          " con un ingreso mensual de $ " +
          this.model.personaDto.empleo.ingresoNeto;
      } else {
        info = info + ", no registra ingresos";
      }

      return info;
    },
    infoconsultaCredito: function () {
      if (!this.model.consultaCredito) return null;

      var info =
        "El resultado de la Consulta fue " + this.model.consultaCredito.estado;

      if (
        this.model.consultaCredito.estado.includes("APROBADO") ||
        this.model.consultaCredito.estado.includes("INGRESADA")
      )
        if (this.model.consultaCredito.cupo == 0)
          info = info + ", pero requiere posterior análisis";
        else
          info = info + ", con un CUPO de $ " + this.model.consultaCredito.cupo;

      return info;
    },
    infoCredito: function () {
      if (this.cuotaSeleccionada == 0)
        return "No se seleccionó la cantidad de cuotas";

      return (
        "Se está solicitando un monto de $" +
        this.model.capital +
        " en " +
        this.cuotaSeleccionada.cuotas +
        " de $ " +
        this.cuotaSeleccionada.importeCuota
      );
    },
    hayProductosNoDisponibles: function () {
      return (
        this.listProductos &&
        this.listProductos.filter((p) => !p.estaDisponible).length > 0
      );
    },
    hayPlanesNoDisponibles: function () {
      return (
        this.listPlanes &&
        this.listPlanes.filter((p) => !p.estaDisponible).length > 0
      );
    },
    puedeContinuarPaso2: function () {
      return (
        this.model.consultaCredito &&
        (this.model.consultaCredito.estado.includes("APROBADO") ||
          this.model.consultaCredito.estado.includes("INGRESADA"))
      );
    },
    puedeContinuarPaso3: function () {
      return (
        this.model.cuotas &&
        this.model.cuotas > 0 &&
        this.model.planId &&
        this.model.planId > 0
      );
    },
    tieneConsultasAprobadas: function () {
      return this.listConsultasAprobadas.length > 0;
    },
    colorEstado: function () {
      if (!this.model.consultaCredito.estado) return;

      if (this.model.consultaCredito.estado == "APROBADO CON CUPO")
        return "green";
      if (this.model.consultaCredito.estado == "APROBADO SIN CUPO")
        return "yellow";
      if (this.model.consultaCredito.estado == "RECHAZADO") return "red";
      return "";
    },
    tipoProductoDescripcion: function () {
      if (this.listProductos && this.model.productoId > 0) {
        return this.listProductos.find(
          (p) => p.productoId === this.model.productoId,
        ).tipoProductoDescripcion;
      }
      return "";
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async nextStep(currentStep) {
      if (currentStep == 1) {
        if (!this.model.productoId || this.model.productoId == 0) {
          this.alertError(
            "Antes de continuar, seleccione el Producto a solicitar",
          );
          return;
        }

        if (!this.infoCrediticia) {
          this.alertError(
            "Antes de continuar, realice la búsqueda del solicitante (con la lupita al lado del documento)",
          );
          return;
        }

        if (this.model.entidadFinancieraId == null) {
          this.alertError(
            "Antes de continuar, seleccione el Banco a consultar",
          );
          return;
        }

        if (this.celular.length > 0 && !this.celularValidado) {
          this.alertError(
            "Se ha ingresado un celular, por favor, verifique que el mismo sea válido.",
          );
          return;
        }

        // if (
        //   this.esCelular &&
        //   (this.celular == null ||
        //     this.imei == null ||
        //     this.celular == "" ||
        //     this.imei == "")
        // ) {
        //   this.alertWarning("Requiere Datos Celular.");
        //   return;
        // }

        if (
          this.showAgregarDocumentacion &&
          this.archivosASubirDocumentacion.length == 0
        ) {
          this.alertWarning(
            "Por favor, adjunte los archivo de Documentación necesarios para el análisis de la solicitud.",
          );
          return;
        }

        let result = await this.$refs.paso1.validate();
        if (!result) {
          this.alertWarning(
            "Por favor, complete los datos requeridos para continuar.",
          );
          return;
        }

        await this.ingresarConsultaCredito();
      } else if (currentStep == 2) {
        this.step++;
      } else if (currentStep == 3) {
        let result = await this.$refs.paso3.validate();
        if (!result) {
          this.alertWarning(
            "Por favor, complete los datos requeridos para continuar.",
          );
          return;
        }

        if (
          this.model.consultaCredito.topeProducto > 0 &&
          this.model.consultaCredito.topeProducto < this.capitalIngresado
        ) {
          this.alertWarning(
            "Por favor, ingrese un importe de capital menor a " +
              this.model.consultaCredito.topeProducto +
              ", ya que es el máximo aprobado.",
          );
          return;
        }

        if (
          this.model.consultaCredito.cupo > 0 &&
          this.model.consultaCredito.cupo < this.importeCuotaMaximaIngresado
        ) {
          this.alertWarning(
            "Por favor, ingrese un importe de cuota menor a " +
              this.model.consultaCredito.cupo +
              ", ya que es el máximo aprobado.",
          );
          return;
        }

        if (
          this.model.modificaOferta &&
          this.model.motivoModificacionOferta == "" &&
          this.model.importeCuota > this.model.consultaCredito.cupo
        ) {
          this.alertError(
            "Por favor, ingrese el motivo por el cual solicita modificar la oferta.",
          );
          return;
        }

        // si la politica requiere débito, busca la info de anses
        var plan = this.listPlanesDisponibles.find(
          (i) => i.planId == this.model.planId,
        );
        if (
          plan.requiereDebitoEnCuenta &&
          this.tipoProductoDescripcion
            .toUpperCase()
            .includes("DIRIGIDO CONSUMO")
        ) {
          // si el producto es de dirigido consumo, busco el cbu la base de anses
          await this.traerInfoAnses();
        }

        //TEST

        // busco la info de canal de venta para fijar grupo
        if (this.model.tipoMedioPagoId == 5) {
          try {
            const infoCanal = await http.get(
              "canalesVenta/" + this.model.canalVentaId,
            );
            //console.log(infoCanal);
            if (!infoCanal.grupoComercialId) {
              this.alertError(
                "Atención, no se configuró el Grupo Comercial asociado al Canal de Venta. Por favor, informe a sistemas.",
              );
            } else {
              Vue.set(
                this.model,
                "pagoAGrupoComercialId",
                infoCanal.grupoComercialId,
              );
            }
          } catch (error) {
            // Error
            this.alertError(error);
          }
        }

        // si la consulta devuelve que se  requiere debito en tarjeta, lo marco de forma predeterminada
        if (
          this.model.consultaCredito.medioCobro == "TARJETA DE DEBITO" ||
          this.productoDescripcion.toLowerCase().includes("tarjeta debito")
        ) {
          this.model.solicitaDebitoATarjeta = true;
          this.model.tarjetaDebito.activa = true;
        }

        this.step++;
      }
    },
    async loadModelos() {
      this.loading = true;
      try {
        var result = await http.get("tipoModeloTelefono");
        this.listModelos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async retomarConsulta(consulta) {
      // veo si ya tiene datos de monto y cuotas cargados
      console.log("consulta");
      console.log(consulta);
      // console.log(this.model.consultaCredito)

      this.model.empresaId = consulta.empresaId;
      this.model.canalVentaId = consulta.canalVentaId;

      this.model.personaId = this.model.personaDto.id;
      Vue.set(this.model, "productoId", consulta.productoId);

      this.model.consultaCredito.cupo = consulta.cupo;
      this.model.consultaCredito.id = consulta.id;
      this.model.consultaCredito.topeProducto = consulta.topeProducto;
      this.model.consultaCredito.medioCobro = consulta.medioCobro;

      if (consulta.solicitanteId == "00000000-0000-0000-0000-000000000000") {
        this.model.personaDto.nombre = consulta.nombre;
        this.model.personaDto.apellido = consulta.apellido;
      }

      this.model.personaDto.empleo.ingresoNeto = consulta.ingresoMensual;

      // solo si la persona no tiene empleador asignado (regla: no pisar datos ya
      // cargados; antes quedaba Id "SIN EMPLEADOR DEFINIDO" con el nombre viejo)
      if (
        consulta.motorEmpleadorId &&
        !this.model.personaDto.empleo.empleadorId
      ) {
        this.model.personaDto.empleo.empleadorId = consulta.motorEmpleadorId;
      }

      if (
        consulta.motorEmpleoCuit &&
        consulta.motorEmpleoCuit != "" &&
        this.model.personaDto.empleo.cui == 0
      ) {
        this.model.personaDto.empleo.cui = consulta.motorEmpleoCuit;
        this.model.personaDto.empleo.empleador =
          consulta.motorEmpleoRazonSocial;
        this.model.personaDto.fechaIngreso = this.$moment(
          consulta.motorEmpleoFechaIngreso,
        ).format("YYYY-MM-DD");

        this.model.personaDto.empleo.situacionLaboralId =
          consulta.motorSituacionLaboralId;
        this.model.personaDto.empleo.situacionLaboralActividadId =
          consulta.motorSituacionLaboralActividadId;

        // lo copio acá para que se refresque la UI
        this.model.personaDto.tipoSituacionLaboralId =
          consulta.motorSituacionLaboralId;
      }

      // solo si la persona no tiene empleador asignado (regla: no pisar datos ya
      // cargados; antes quedaba Id "SIN EMPLEADOR DEFINIDO" con el nombre viejo)
      if (
        consulta.motorEmpleadorId &&
        !this.model.personaDto.empleo.empleadorId
      ) {
        this.model.personaDto.empleo.empleadorId = consulta.motorEmpleadorId;
      }

      if (consulta.motorDireccion) {
        let direccionSeparada = consulta.motorDireccion.split("-");

        if (direccionSeparada.length == 5) {
          if (this.model.personaDto.domicilios.length == 0) {
            this.model.personaDto.domicilios.push({
              calle: direccionSeparada[0],
              numero: direccionSeparada[1],
              piso: "",
              departamento: "",
              localidad: direccionSeparada[2],
              codigoPostal: direccionSeparada[3],
              provincia: direccionSeparada[4],
            });
          } else {
            this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
            this.model.personaDto.domicilios[0].numero = direccionSeparada[1];
            this.model.personaDto.domicilios[0].localidad =
              direccionSeparada[2];
            this.model.personaDto.domicilios[0].codigoPostal =
              direccionSeparada[3];
            this.model.personaDto.domicilios[0].provincia =
              direccionSeparada[4];
          }
        } else if (direccionSeparada.length == 4) {
          if (this.model.personaDto.domicilios.length == 0) {
            this.model.personaDto.domicilios.push({
              calle: direccionSeparada[0],
              numero: "",
              piso: "",
              departamento: "",
              localidad: direccionSeparada[1],
              codigoPostal: direccionSeparada[2],
              provincia: direccionSeparada[3],
            });
          } else {
            this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
            this.model.personaDto.domicilios[0].localidad =
              direccionSeparada[1];
            this.model.personaDto.domicilios[0].codigoPostal =
              direccionSeparada[2];
            this.model.personaDto.domicilios[0].provincia =
              direccionSeparada[3];
          }
        } else if (direccionSeparada.length == 3) {
          if (this.model.personaDto.domicilios.length == 0) {
            this.model.personaDto.domicilios.push({
              calle: direccionSeparada[0],
              numero: "",
              piso: "",
              departamento: "",
              localidad: direccionSeparada[1],
              codigoPostal: "",
              provincia: direccionSeparada[2],
            });
          } else {
            this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
            this.model.personaDto.domicilios[0].localidad =
              direccionSeparada[1];
            this.model.personaDto.domicilios[0].provincia =
              direccionSeparada[2];
          }
        } else if (direccionSeparada.length > 0) {
          if (this.model.personaDto.domicilios.length == 0) {
            this.model.personaDto.domicilios.push({
              calle: direccionSeparada[0],
              numero: "",
              piso: "",
              departamento: "",
              localidad: "",
              codigoPostal: "",
              provincia: "",
            });
          } else {
            this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
          }
        }
      }

      this.model.consultaCredito.estado = "APROBADA CON CUPO";

      this.model.montoRenovacion = consulta.importeRenovacion;
      this.model.montoRenovacionAsignado = consulta.importeRenovacion > 0;

      this.model.montoRetencion = consulta.importeRetencion;
      this.model.montoRetencionAsignado = consulta.importeRetencion > 0;

      console.log("this.model.consultaCredito");
      console.log(this.model.consultaCredito);

      await this.loadPlanesDisponibles();

      if (consulta.planId > 0) {
        this.model.planId = consulta.planId;
        //todo: bloquear planDiaCobroId
        await this.setPoliticaComercial(); // vuelvo a calcula la politica porque cambia el plan
      }

      if (consulta.monto > 0) {
        this.ingresoPorMonto = "true";
        this.capitalIngresado = consulta.monto;
        await this.calcularOpcionesPlan();
      } else {
        if (this.model.consultaCredito.topeProducto > 0) {
          this.ingresoPorMonto = "true";
          this.capitalIngresado = this.model.consultaCredito.topeProducto;
          await this.calcularOpcionesPlan();
        } else if (this.model.consultaCredito.cupo > 0) {
          this.ingresoPorMonto = "false";
          this.importeCuotaMaximaIngresado = this.model.consultaCredito.cupo;
          await this.calcularOpcionesPlan();
        }
      }

      // veo si tiene una cantidad de cuotas seteada
      if (consulta.cuotas > 0 && this.opcionesPlanes) {
        var itemPlan = this.opcionesPlanes.find(
          (i) => i.cuotas == consulta.cuotas,
        );

        if (itemPlan) {
          this.setCuotaSeleciconada(itemPlan);
        }
      }

      // seteo datos adicionales
      if (consulta.motivoSolicitudId > 0)
        this.model.tipoMotivoSolicitudId = consulta.motivoSolicitudId;

      if (consulta.formaLlegadaId > 0)
        this.model.tipoFormaLlegadaId = consulta.formaLlegadaId;

      this.productoDescripcion = this.listProductos.find(
        (x) => x.productoId == this.model.productoId,
      ).productoDescripcion;

      // if(consulta.medioPagoId > 0)
      //   this.model.tipoMedioPagoId = consulta.medioPagoId;

      this.model.cuentaDebito.debitoATitular = consulta.debitoEnCuenta;
      this.model.cuentaDebito.debitoAGarante = consulta.debitoEnCuentaGarante;
      if (consulta.cbuId > 0) this.model.model.cuentaBancoId = consulta.cbuId;

      this.showConsultasAprobadas = false;

      this.step = 2;
    },
    async confirmarAlta(dejarPendiente) {
      if (
        this.esCelular &&
        (this.celular == null ||
          this.model.imei == null ||
          this.model.celular == "" ||
          this.model.imei == "")
      ) {
        this.alertWarning("Requiere Datos Celular.");
        return;
      }

      // solo valido si se confirma la carga (si se deja pendiente, no)
      if (!dejarPendiente) {
        if (
          this.model.consultaCredito.medioCobro == "TARJETA DE DEBITO" ||
          this.productoDescripcion.toLowerCase().includes("tarjeta debito")
        ) {
          console.log("validacion tarjeta ");
          console.log(this.model.tarjetaDebito);
          if (
            this.model.solicitaDebitoATarjeta &&
            (this.model.tarjetaDebito.numero == undefined ||
              this.model.tarjetaDebito.tarjetaId == undefined ||
              this.model.tarjetaDebito.token == undefined ||
              !this.model.tarjetaDebito.activa)
          ) {
            this.alertWarning(
              "Por favor, complete los datos de la tarjeta, y verifique que se encuentre el Débito Activo..",
            );
            return;
          }
        }

        // if (
        //   this.esCelular &&
        //   (this.celular == null ||
        //     this.imei == null ||
        //     this.celular == "" ||
        //     this.imei == "")
        // ) {
        //   this.alertWarning("Requiere Datos Celular.");
        //   return;
        // }

        if (!this.politicaAprobada && !this.model.seAutorizoPorExcepcion) {
          this.alertWarning(
            "La Política no ha sido validada. Imposible continuar.",
          );
          return;
        }

        if (!this.legajoCheck) {
          this.alertWarning(
            "Por favor, revise y complete el Legajo de Solicitante antes de confirmar.",
          );
          return;
        }

        if (
          this.model.tarjetaDebito.activa &&
          (this.model.cuentaDebito.debitoATitular ||
            this.model.cuentaDebito.debitoAGarante)
        ) {
          this.alertWarning(
            "No puede seleccionarse Débito en Cuenta y Debito por Tarjeta al mismo tiempo. Por favor, verifique.",
          );
          return;
        }

        if (this.showAgregarLegajo && this.archivosASubirLegajo.length == 0) {
          this.alertWarning(
            "Por favor, adjunte los archivo necesarios para el análisis de la solicitud.",
          );
          return;
        }

        if (
          this.tipoProductoDescripcion
            .toUpperCase()
            .includes("DIRIGIDO CONSUMO") &&
          !this.model.productoAEntregar
        ) {
          this.alertWarning("Por favor, ingrese el Producto a Entregar.");
          return;
        }

        if (this.model.solicitaDebito) {
          if (!this.model.cuentaDebito) {
            this.alertWarning(
              "Por favor, ingrese los datos de la Cuenta de Débito.",
            );
            return;
          }

          if (
            !this.model.cuentaDebito.debitoATitular &&
            !this.model.cuentaDebito.debitoAGarante
          ) {
            this.alertWarning(
              "Por favor, indique si el débito se realizará el Titular o al Garante.",
            );
            return;
          }

          if (
            this.model.cuentaDebito.altaCuenta &&
            this.model.cuentaDebito.cbu == ""
          ) {
            this.alertWarning(
              "Por favor, ingrese los datos de la nueva Cuenta de Débito.",
            );
            return;
          }

          if (
            !this.model.cuentaDebito.altaCuenta &&
            this.model.cuentaDebito.cuentaBancoId == null
          ) {
            this.alertWarning("Por favor, seleccione la Cuenta de Débito.");
            return;
          }

          if (!this.model.cuentaDebito.diaCobroId) {
            this.alertWarning("Por favor, seleccione el Día de Cobro.");
            return;
          }
        }

        if (this.model.solicitaDebitoATarjeta) {
          if (
            !this.model.tarjetaDebito ||
            (!this.model.tarjetaDebito.tarjetaValidada &&
              this.model.tarjetaDebito.tokenizadaPorId != 2)
          ) {
            this.alertWarning(
              "Por favor, ingrese y valide la Tarjeta a debitar.",
            );
            return;
          }
        }
      }

      this.loading = true;
      try {
        this.model.politicaComercialId = this.politicaComercial.id;
        this.model.consultaId = this.model.consultaCredito.id;
        this.model.personaId = this.model.personaDto.id;
        this.model.dejarPendiente = dejarPendiente;

        if (this.showAgregarLegajo && this.archivosASubirLegajo.length > 0)
          this.model.agregaLegajoFirmado = true;
        else this.model.agregaLegajoFirmado = false;

        this.showSaveProgress = true;
        this.saving = true;
        this.uploading = true;

        var result = await http.post(
          "creditos/upgradefromconsulta",
          JSON.stringify({ solicitud: this.model }),
        );

        console.log(this.model);

        this.saving = false;

        if (this.archivosASubirLegajo.length > 0) {
          await this.uploadFilesLegajo(false);
          this.uploading = false;
        }

        if (result.acciones) {
          this.productoDescripcion = this.listProductos.find(
            (x) => x.productoId == this.model.productoId,
          ).productoDescripcion;

          this.saveResults = result;
          this.showSaveResults = true;
          this.impresionCreditoId = this.model.consultaId;
          this.impresionCreditoEmpresaId = this.model.empresaId;

          // var mensaje = ''
          // for (let index = 0; index < result.acciones.length; index++) {
          //     const accion = result.acciones[index];
          //     mensaje = mensaje + accion + '<br>'
          // }
          // const res = await this.$dialog.confirm({
          //     text: mensaje,
          //     title: 'Se realizaron las siguientes acciones',
          //     actions: {
          //         false: '',
          //         true: {
          //             text: 'OK',
          //             color: 'primary'
          //         }
          //     },
          //     persistent: true // Parece que no funciona...
          // });
        }

        //this.clear()
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
      this.showSaveProgress = false;
    },
    test() {
      this.saveResults.acciones = [];
      this.saveResults.acciones.push("Se generó Plan de pagos");
      this.saveResults.acciones.push("Se asignó Nro credito 45454");
      this.saveResults.acciones.push(
        "Link Güeno: http://argenpesos.gueno.com.ar?id=965D96FF-A78A-4241-8FA8-F5B866943085",
      );
      this.saveResults.acciones.push(
        "Link CardCred: https://pcicardcred.com.ar/tokenizar.aspx?id=20&tipo=D",
      );

      this.showSaveResults = true;
    },
    async uploadFiles() {
      if (this.archivosASubirDocumentacion.length === 0) {
        this.alertWarning(
          "No se ha seleccionado ningún archivo para subir al legajo.",
        );
        return;
      }
      if (!this.model.consultaCredito.id) {
        this.alertWarning(
          "Debe realizar la consulta antes de adjuntar la documentacion (Id de Consulta vacío).",
        );
        return;
      }

      const response = await legajoVirtualService.uploadLegajoVirtual(
        this.model.personaDto.documento,
        null,
        this.model.consultaCredito.id,
        this.model.empresaId,
        this.archivosASubirDocumentacion,
        false,
        "",
        "documentacion",
      );

      if (response.success) {
        this.alertSuccess(response.message);
        this.archivosASubirDocumentacion = [];
      } else {
        this.alertError(response.message);
        this.errorAlAgregarDocumentacion = true;
        return false;
      }

      // const formData = new FormData();

      // formData.append('documento', this.model.personaDto.documento);
      // formData.append('creditoId', this.model.consultaCredito.id);
      // formData.append('empresaId', this.model.empresaId);
      // formData.append('tipoDocumentacion', 'documentacion');

      // for (let i = 0; i < this.archivosASubirDocumentacion.length; i++) {
      //   formData.append('files', this.archivosASubirDocumentacion[i]);
      // }

      // try {
      //   await http.post('/personas/uploadfileslegajovirtual', formData);

      //   //this.alertSuccess('Los archivos se subieron con éxito.');

      //   this.archivosASubirDocumentacion = [];
      // } catch (error) {
      //   // Error
      //   this.alertError(error);
      //   this.errorAlAgregarDocumentacion = true;
      //   return false;
      // }
      return true;
    },
    async uploadFilesLegajo(completaDocumentacion) {
      if (this.archivosASubirLegajo.length === 0) {
        this.alertWarning(
          "No se ha seleccionado ningún archivo para subir al legajo.",
        );
        return;
      }
      if (!this.model.consultaCredito.id) {
        this.alertWarning(
          "Debe realizar la consulta antes de adjuntar la documentacion (Id de Consulta vacío).",
        );
        return;
      }

      const formData = new FormData();

      formData.append("documento", this.model.personaDto.documento);
      formData.append("creditoId", this.model.consultaCredito.id);
      formData.append("empresaId", this.model.empresaId);
      formData.append("tipoDocumentacion", "legajoCredito");

      if (completaDocumentacion) formData.append("completaDocumentacion", true);

      for (let i = 0; i < this.archivosASubirLegajo.length; i++) {
        formData.append("files", this.archivosASubirLegajo[i]);
      }

      try {
        await http.post("/personas/uploadfileslegajovirtual", formData);

        if (completaDocumentacion)
          this.alertSuccess("El legajo fue completado con éxito.");
        else this.alertSuccess("Se ha adjuntado la documentación.");
        if (this.$store.state.modoCargaRapidaComer) this.$router.push("/home");

        this.archivosASubirLegajo = [];
      } catch (error) {
        // Error
        this.alertError(error);
        this.errorAlAgregarLegajo = true;
        return false;
      }
      return true;
    },
    async setCuotaSeleciconada(item) {
      this.indiceOferta = item.indice;
      this.cuotaSeleccionada = item;
      this.model.capital = this.cuotaSeleccionada.capital;
      this.model.cuotas = this.cuotaSeleccionada.cuotas;
      this.model.importeCuota = this.cuotaSeleccionada.importeCuota;
      this.model.tablaCoeficientesId =
        this.cuotaSeleccionada.tablaCoeficienteId;
    },
    async selectedProductoChanged(value) {
      if (value == 0) {
        this.productoDescripcion = "";
        return;
      }

      this.productoDescripcion = this.listProductos.find(
        (p) => p.productoId === value,
      ).productoDescripcion;

      await this.setPoliticaComercial();
    },
    async selectedPlanChanged(value) {
      if (value == 0) return;

      await this.setPoliticaComercial();
      await this.calcularOpcionesPlan();
    },
    async situacionLaboralChanged() {
      if (this.model.personaDto.empleo)
        this.model.personaDto.empleo.situacionLaboralId =
          this.model.personaDto.tipoSituacionLaboralId;
    },
    async retomarConsultaCredito(consultaId) {
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/getinforesumida?id=" + consultaId,
        );

        if (result != null) {
          // veo si el usuario tiene el canal de venta de la consulta habilitado
          if (
            !this.listCanalesVentaHabilitados.find(
              (c) => c.id == result.canalVentaId,
            )
          ) {
            this.alertError(
              "Atención, no tiene habilitado el Canal de Venta:" +
                result.canalVentaNombre +
                ", al que pertenece la consulta. Imposible Retomar.",
            );
            return;
          } else {
            this.model.canalVentaId = result.canalVentaId;
          }

          this.ingresoPor = "cuil";
          this.model.cui = result.personaCuil;
          await this.buscarPersonaPorDocumento(this.model.cui);

          this.showConsultasAprobadas = true;
        } else {
          this.alertError("Atención, ID de consulta inválido:" + consultaId);
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async traerInfoAnses() {
      this.loading = true;
      try {
        var result = await http.get(
          "personas/getinfoanses?cuil=" + this.model.cui,
        );

        console.log("datos anses");
        console.log(result);

        this.cuentaDebitoAnses = false;

        if (
          result != null &&
          result.count > 0 &&
          this.model.personaDto.cuentasBanco.length == 0
        ) {
          // si no tiene cuentas cargadas (y trajo algo de la info de anses)

          // si los dígitos del banco seleccionado coinciden con el recuperado de cuentaDebitoAnses
          // lo uso, si no, no
          var usarCbuAnses = false;
          var codigoEntidadFinanciera = this.listEntidadesFinancieras.find(
            (x) => x.id == this.model.entidadFinancieraId,
          ).codigo;

          if (codigoEntidadFinanciera == result.list[0].cbu.substring(0, 3))
            usarCbuAnses = false; // modificado el 28/6/21, se pidió deshabilitar esta funcionalidad

          if (usarCbuAnses) {
            Vue.nextTick(() => {
              // esto es para esperar a que se renderice el componente nuevo
              Vue.set(this.model, "solicitaDebito", true);
              Vue.set(this, "cuentaDebitoAnses", true);

              var nuevaCuenta = {
                creditoId: this.model.consultaCredito.id,
                altaCuenta: true,
                diaCobroId: 1,
                cbu: result.list[0].cbu,
                tipoCuentaId: 1,
                debitoATitular: true,
              };

              Vue.set(this.model, "cuentaDebito", nuevaCuenta);
            });
          }
        } else {
          // no hay info
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async continuarACargaCompleta() {
      await this.loadPlanesDisponibles();

      if (this.model.consultaCredito.planId) {
        this.model.planId = this.model.consultaCredito.planId;
      }

      if (this.model.consultaCredito.cupo > 0) {
        this.ingresoPorMonto = "false";
        this.importeCuotaMaximaIngresado = this.model.consultaCredito.cupo;
        await this.calcularOpcionesPlan();
      } else if (this.model.consultaCredito.topeProducto > 0) {
        this.ingresoPorMonto = "true";
        this.capitalIngresado = this.model.consultaCredito.topeProducto;
        await this.calcularOpcionesPlan();
      }
      this.nextStep(2);
    },
    async nuevoProspecto() {
      var dob = this.$moment(this.model.personaDto.fechaNacimiento);

      var edad = "";
      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        edad = Math.abs(ageDate.getUTCFullYear() - 1970);
      }

      var editProspecto = {
        nombre: this.model.personaDto.nombre,
        documento: this.model.personaDto.documento,
        fechaNacimiento: edad,
        ingresos: this.model.personaDto.empleo.ingresoNeto,
        sexoId: this.model.personaDto.tipoSexoId,
        montoSolicitado: this.model.consultaCredito.topeProducto,
        cuotaMaxima: this.model.consultaCredito.cupo,
      };

      var params = {
        width: 500,
        prospectoId: "00000000-0000-0000-0000-000000000000",
        editModeProp: true,
        editProspecto: editProspecto,
      };

      this.setActiveTask({
        task: "alta-modificacion-prospecto",
        props: params,
      });
    },

    async ingresarConsultaCredito() {
      this.loading = true;

      this.showSaveProgressConsulta = true;

      this.uploading = true;
      this.saving = true;

      try {
        var ingresos = this.model.personaDto.empleo.ingresoNeto;
        var movimientos = this.model.movimientos;
        if (this.modalidadAltaId == 2) {
          // en este caso no mando los valores
          ingresos = 0;
          movimientos = 0;
        }

        var parametros = {
          canalVentaId: this.model.canalVentaId,
          productoId: this.model.productoId,
          calificacionPersonaId: this.infoCrediticia.tipoCalificacionId,
          cuil: this.model.personaDto.cui,
          nombre: this.model.personaDto.nombre,
          apellido: this.model.personaDto.apellido,
          personaId: this.model.personaDto.id,
          ingresoMensual: ingresos,
          movimientos: movimientos,
          entidadFinancieraId: this.model.entidadFinancieraId,
          modalidadAltaId: this.modalidadAltaId,
          categoriaClienteId: this.infoCrediticia.tipoCategoriaClienteId,
          celular: this.celular,
          modelo: this.modelo,
          imei: this.imei,
        };

        var result = await http.post(
          "creditos/crearconsulta",
          JSON.stringify({ solicitud: parametros }),
        );

        this.model.consultaCredito = result.entity;

        //si el resultado es tomado del analista
        if (this.model.consultaCredito.resultadoTomadoDeAnalista) {
          this.model.consultaCredito.resultado =
            this.model.consultaCredito.estado + " || Por Analista";
        }

        // completo los datos en base a lo que vino
        if (
          this.model.consultaCredito.motorNombre &&
          this.model.consultaCredito.motorNombre != ""
        ) {
          // si no se ingresó nombre, pero se pudo recuperar, lo cargo
          this.model.personaDto.nombre = this.model.consultaCredito.motorNombre;
          this.canEditNombre = true;
        } else {
          this.canEditNombre = false;
        }

        if (
          this.model.consultaCredito.motorApellido &&
          this.model.consultaCredito.motorApellido != ""
        ) {
          // si no se ingresó apellido, pero se pudo recuperar, lo cargo
          this.model.personaDto.apellido =
            this.model.consultaCredito.motorApellido;
          this.canEditNombre = true;
        } else {
          this.canEditNombre = false;
        }

        if (
          this.model.consultaCredito.motorFechaNacimiento &&
          this.model.consultaCredito.motorFechaNacimiento != "" &&
          this.model.consultaCredito.motorFechaNacimiento != ""
        ) {
          var fechaNac = this.$moment(
            this.model.consultaCredito.motorFechaNacimiento,
          ).format("YYYY-MM-DD");
          if (fechaNac != "0001-01-01") {
            // si no se ingresó apellido, pero se pudo recuperar, lo cargo
            this.model.personaDto.fechaNacimiento = fechaNac;
          }
        }

        if (
          this.model.consultaCredito.motorEmpleoCuit &&
          this.model.consultaCredito.motorEmpleoCuit != "" &&
          this.model.personaDto.empleo.cui == 0
        ) {
          this.model.personaDto.empleo.cui =
            this.model.consultaCredito.motorEmpleoCuit;
          this.model.personaDto.empleo.empleador =
            this.model.consultaCredito.motorEmpleoRazonSocial;
          this.model.personaDto.fechaIngreso = this.$moment(
            this.model.consultaCredito.motorEmpleoFechaIngreso,
          ).format("YYYY-MM-DD");

          this.model.personaDto.empleo.situacionLaboralId =
            this.model.consultaCredito.motorSituacionLaboralId;
          this.model.personaDto.empleo.situacionLaboralActividadId =
            this.model.consultaCredito.motorSituacionLaboralActividadId;

          // lo copio acá para que se refresque la UI
          this.model.personaDto.tipoSituacionLaboralId =
            this.model.consultaCredito.motorSituacionLaboralId;
        }

        // solo si la persona no tiene empleador asignado (regla: no pisar datos ya
        // cargados; antes quedaba Id "SIN EMPLEADOR DEFINIDO" con el nombre viejo)
        if (
          this.model.consultaCredito.motorEmpleadorId &&
          !this.model.personaDto.empleo.empleadorId
        ) {
          this.model.personaDto.empleo.empleadorId =
            this.model.consultaCredito.motorEmpleadorId;
        }

        if (this.model.consultaCredito.motorDireccion) {
          let direccionSeparada =
            this.model.consultaCredito.motorDireccion.split("-");

          if (direccionSeparada.length == 5) {
            if (this.model.personaDto.domicilios.length == 0) {
              this.model.personaDto.domicilios.push({
                calle: direccionSeparada[0],
                numero: direccionSeparada[1],
                piso: "",
                departamento: "",
                localidad: direccionSeparada[2],
                codigoPostal: direccionSeparada[3],
                provincia: direccionSeparada[4],
              });
            } else {
              this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
              this.model.personaDto.domicilios[0].numero = direccionSeparada[1];
              this.model.personaDto.domicilios[0].localidad =
                direccionSeparada[2];
              this.model.personaDto.domicilios[0].codigoPostal =
                direccionSeparada[3];
              this.model.personaDto.domicilios[0].provincia =
                direccionSeparada[4];
            }
          } else if (direccionSeparada.length == 4) {
            if (this.model.personaDto.domicilios.length == 0) {
              this.model.personaDto.domicilios.push({
                calle: direccionSeparada[0],
                numero: "",
                piso: "",
                departamento: "",
                localidad: direccionSeparada[1],
                codigoPostal: direccionSeparada[2],
                provincia: direccionSeparada[3],
              });
            } else {
              this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
              this.model.personaDto.domicilios[0].localidad =
                direccionSeparada[1];
              this.model.personaDto.domicilios[0].codigoPostal =
                direccionSeparada[2];
              this.model.personaDto.domicilios[0].provincia =
                direccionSeparada[3];
            }
          } else if (direccionSeparada.length == 3) {
            if (this.model.personaDto.domicilios.length == 0) {
              this.model.personaDto.domicilios.push({
                calle: direccionSeparada[0],
                numero: "",
                piso: "",
                departamento: "",
                localidad: direccionSeparada[1],
                codigoPostal: "",
                provincia: direccionSeparada[2],
              });
            } else {
              this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
              this.model.personaDto.domicilios[0].localidad =
                direccionSeparada[1];
              this.model.personaDto.domicilios[0].provincia =
                direccionSeparada[2];
            }
          } else if (direccionSeparada.length > 0) {
            if (this.model.personaDto.domicilios.length == 0) {
              this.model.personaDto.domicilios.push({
                calle: direccionSeparada[0],
                numero: "",
                piso: "",
                departamento: "",
                localidad: "",
                codigoPostal: "",
                provincia: "",
              });
            } else {
              this.model.personaDto.domicilios[0].calle = direccionSeparada[0];
            }
          }
        }

        if (this.model.consultaCredito.estado != "RECHAZADO") {
          if (
            this.model.consultaCredito.motorCuil &&
            this.model.consultaCredito.motorCuil != ""
          ) {
            if (this.model.personaDto.cui == 0) {
              this.model.personaDto.cui = this.model.consultaCredito.motorCuil;
            } else if (
              this.model.consultaCredito.motorCuil != this.model.personaDto.cui
            ) {
              //console.log(this.model.consultaCredito.motorCuil)
              //console.log(this.model.personaDto.cui)

              // no coincide el cuil cargado con el recuperado del motor, aviso
              const res = await this.$dialog.confirm({
                text: "El CUIL recuperado desde el Motor no coincide con el cargado en el Sistema. ¿Desea utilizar el del Motor?",
                title: "Atención",
                persistent: true, // Parece que no funciona...
              });

              if (res) {
                this.model.personaDto.cui =
                  this.model.consultaCredito.motorCuil;
              }
            }
          }
        }

        // includes("RECHAZA") contempla RECHAZADO/RECHAZADA (antes comparaba ==
        // "RECHAZA", que nunca matcheaba y el flujo seguía tras un rechazo)
        if (this.model.consultaCredito.estado == "RECHAZA") {
          this.alertError(
            "La consulta ha sido RECHAZADA. Puede ver más información en las Variables del Motor.",
          );
          return false;
        } else if (this.model.consultaCredito.estado == "APROBADO CON CUPO") {
          //
        } else if (this.model.consultaCredito.estado == "APROBADO SIN CUPO") {
          //this.step=2;
        } else if (this.model.consultaCredito.estado == "INGRESADA") {
          //this.step=2;
        }

        // si la consulta devuelve que se  requiere debito en tarjeta, lo marco de forma predeterminada
        if (
          this.model.consultaCredito.medioCobro == "TARJETA DE DEBITO" ||
          this.productoDescripcion.toLowerCase().includes("tarjeta debito")
        ) {
          this.model.solicitaDebitoATarjeta = true;
          this.model.tarjetaDebito.activa = true;
        }

        // subo la documentación
        if (this.showAgregarDocumentacion) {
          if (this.archivosASubirDocumentacion.length > 0) {
            var res = await this.uploadFiles();
            if (res) {
              this.uploading = false;
            } else {
              return false;
            }
          }
        }

        this.consultarVisible = false;
        this.showResultadoConsulta = true;
      } catch (error) {
        // Error
        this.alertError(error);
        return false;
      } finally {
        this.loading = false;
        this.showSaveProgressConsulta = false;
      }

      return true;
    },
    async loadConsultasAprobadas() {
      // busco las posibles consultas aprobadas para la persona
      this.listConsultasAprobadas = [];

      this.loadingProgress = true;
      try {
        var result = await http.get(
          "creditos/listconsultaspararetomarporpersona" +
            "?cui=" +
            this.model.cui +
            "&canalVentaId=" +
            this.model.canalVentaId,
        );

        this.listConsultasAprobadas = result.list;

        console.log(this.listConsultasAprobadas);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingProgress = false;
    },
    async calcularOpcionesPlan() {
      this.opcionesPlanes = [];

      if (this.capitalIngresado == 0 && this.importeCuotaMaximaIngresado == 0)
        return;

      if (
        this.ingresoPorMonto == "true" &&
        this.capitalIngresado > this.model.consultaCredito.topeProducto
      ) {
        this.alertWarning(
          "Por favor, verifique el importe ingresado, ya que supera al máximo establecido de " +
            this.model.consultaCredito.topeProducto,
        );
        return;
      }

      if (
        this.ingresoPorMonto == "false" &&
        this.importeCuotaMaximaIngresado > this.model.consultaCredito.cupo
      ) {
        this.alertWarning(
          "Por favor, verifique el importe ingresado, ya que supera al máximo establecido de " +
            this.model.consultaCredito.cupo,
        );
        return;
      }

      this.model.cuotas = 0;
      this.errorPolitica = "";

      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/calcularopcionesplanparacredito" +
            "?planId=" +
            this.model.planId +
            "&empresaId=" +
            this.model.empresaId +
            "&canalVentaId=" +
            this.model.canalVentaId +
            "&calificacionPersonaId=" +
            this.infoCrediticia.tipoCalificacionId +
            "&politicaComercialId=" +
            this.model.politicaComercialId +
            "&diaCobro=" +
            "0" +
            "&capital=" +
            this.capitalIngresado +
            "&importeCuotaMaximo=" +
            this.importeCuotaMaximaIngresado +
            "&ingresoMensual=" +
            this.model.personaDto.empleo.ingresoNeto +
            "&fechaCarga=" +
            this.model.fechaCarga +
            "&excepcionAprobada=" +
            this.politicaAprobada +
            "&esComer=" +
            this.user.esComer +
            "&esComercio=" +
            this.user.esComercio +
            "&topeProducto=" +
            (this.model.consultaCredito
              ? this.model.consultaCredito.topeProducto
              : 0) +
            "&cuotaMaxima=" +
            (this.model.consultaCredito ? this.model.consultaCredito.cupo : 0),
        );

        this.opcionesPlanes = result.list;
        if (result.list.length == 0) {
          this.alertWarning(
            "No se encontraron opciones de cuota para el plan seleccionado.",
          );
        }
      } catch (error) {
        if (JSON.stringify(error).includes("Politica")) {
          this.errorPolitica = error;
        } else {
          // Error
          this.alertError(error);
        }
      }
      this.loading = false;
    },

    async setPoliticaComercial() {
      // busco la política que se esá aplicando en base al producto o plan seleccionado
      if (
        this.$store.state.parametrosGenerales.politicaComercialPor == "producto"
      )
        if (!this.infoCrediticia || !(this.model.productoId > 0)) return;

      if (this.$store.state.parametrosGenerales.politicaComercialPor == "plan")
        if (!this.infoCrediticia || !(this.model.planId > 0)) return;

      this.loadingProgress = true;

      if (
        this.$store.state.parametrosGenerales.politicaComercialPor == "producto"
      ) {
        try {
          var result = await http.get(
            "businesscore/establecerpoliticacomercial" +
              "?productoId=" +
              this.model.productoId +
              "&empresaId=" +
              this.model.empresaId +
              "&canalVentaId=" +
              this.model.canalVentaId +
              "&calificacionPersonaId=" +
              this.infoCrediticia.tipoCalificacionId,
          );

          this.politicaComercial = result;
          this.model.politicaComercialId = this.politicaComercial.id;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          var result = await http.get(
            "businesscore/establecerpoliticacomercial" +
              "?planId=" +
              this.model.planId +
              "&empresaId=" +
              this.model.empresaId +
              "&canalVentaId=" +
              this.model.canalVentaId +
              "&calificacionPersonaId=" +
              this.infoCrediticia.tipoCalificacionId,
          );

          // console.log('Política x Plan:');
          // console.log(result)

          this.politicaComercial = result;
          this.model.politicaComercialId = this.politicaComercial.id;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }

      this.loadingProgress = false;
    },
    async loadPlanesDisponibles() {
      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/planesdisponiblesparacredito" +
            "?productoId=" +
            this.model.productoId +
            "&empresaId=" +
            this.model.empresaId +
            "&canalVentaId=" +
            this.model.canalVentaId +
            "&calificacionPersonaId=" +
            this.infoCrediticia.tipoCalificacionId,
        );

        this.listPlanes = result.list;
        this.listPlanesDisponibles = this.listPlanes.filter(
          (p) => p.estaDisponible,
        );
        if (result.list.length == 0) {
          this.model.planId = 0;
          this.alertWarning(
            "El producto seleccionado no tiene Planes vigentes que estén disponibles. Utilice otro producto.",
          );
        } else {
          this.model.planId = result.list[0].planId;
          await this.setPoliticaComercial();
          await this.calcularOpcionesPlan();
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductosDisponibles() {
      if (this.model.canalVentaId == 0) return;

      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/productosdisponiblesparaconsultamotor" +
            "?empresaId=" +
            this.model.empresaId +
            "&canalVentaId=" +
            this.model.canalVentaId,
        );

        this.listProductos = result.list;
        this.listProductosDisponibles = this.listProductos.filter(
          (p) => p.estaDisponible,
        );
        // si hay uno solo, lo selecciono
        if (this.listProductosDisponibles.length > 0)
          this.model.productoId = this.listProductosDisponibles[0].productoId;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async buscarPersonaPorDocumento(cui) {
      if (this.ingresoPor == "cuil" && cui.toString().length != 11) {
        this.alertError(
          "Por favor, verifique el CUIL ingresado, debe tener 11 dígitos.",
        );
        return;
      }

      this.loading = true;
      var nombre;

      try {
        if (this.ingresoPor == "documento") {
          // se realiza la validacion de identidad (al motor)
          var resultValidacionIdentidad = await http.get(
            "consultasmotorsiisa/validacionidentidad?documento=" +
              Number.parseFloat(cui),
          );

          console.log("resultValidacionIdentidad");
          console.log(resultValidacionIdentidad);

          if (resultValidacionIdentidad.length == 0) {
            this.alertError(
              "El documento ingresado no se encontró en los padrones.",
            );
            this.loading = false;
            return;
          } else if (resultValidacionIdentidad.length == 1) {
            this.ingresoPor = "cuil";
            cui = resultValidacionIdentidad[0].cuil;
            nombre = resultValidacionIdentidad[0].nombre;
          } else {
            // mas de 1
            this.resultadoValidacionIdentidad = resultValidacionIdentidad;
            this.showResultadoValidacionIdentidad = true;
            this.loading = false;
            return;
          }
        }

        var result = await http.get(
          "personas/listaporcui?cui=" + Number.parseFloat(cui),
        );
        if (result.count >= 1) {
          this.setPersonaBusqueda(result.list[0]);
        } else {
          if (cui.toString().length == 11)
            this.setPersonaBusqueda(
              {
                id: "00000000-0000-0000-0000-000000000000",
                documento: 0,
                cui: cui,
                tipoSexoId: this.model.personaDto.tipoSexoId,
              },
              nombre,
            );
          // nuevo ingreso
          else
            this.setPersonaBusqueda(
              {
                id: "00000000-0000-0000-0000-000000000000",
                documento: cui,
                cui: 0,
                tipoSexoId: this.model.personaDto.tipoSexoId,
              },
              nombre,
            ); // nuevo ingreso
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async legajoGuardado(confirmado) {
      this.showLegajo = false;
      if (confirmado) {
        this.legajoCheck = true;
        this.model.personaId = this.model.personaDto.id;
      }
    },
    async setPersonaBusqueda(persona, nombre) {
      this.selectedPersonaBusqueda = persona;
      this.model.personaId = persona.id;

      // busco la info completa de la persona
      this.loadingProgress = true;
      try {
        var result = await http.get(
          "personas/infocrediticia?id=" +
            this.model.personaId +
            "&cuil=" +
            persona.cui +
            "&documento=" +
            persona.documento +
            "&sexoId=" +
            this.model.personaDto.tipoSexoId +
            (this.retomarConsultaId
              ? "&consultaId=" + this.retomarConsultaId
              : ""),
        );

        this.infoCrediticia = result;

        // console.log('info crediticia')
        // console.log(this.infoCrediticia)

        this.model.personaDto = this.infoCrediticia.personaDto;
        if (this.model.personaDto.empleo) {
          this.model.personaDto.empleo.fechaIngreso = this.$moment(
            this.model.personaDto.empleo.fechaIngreso,
          ).format("YYYY-MM-DD");
        }

        if (nombre) this.model.personaDto.nombre = nombre;

        this.model.cui = this.infoCrediticia.cui;

        this.model.calificacionPersonaId =
          this.infoCrediticia.tipoCalificacionId;

        var dob = this.$moment(this.model.personaDto.fechaNacimiento).format(
          "YYYY-MM-DD",
        ); // Todo: ver qué pasa cuando graba
        this.model.personaDto.fechaNacimiento = dob;

        if (this.infoCrediticia.personaDto.tipoSituacionLaboralId > 0) {
          this.model.trabaja = "true";
        }

        // para este tipo de carga, mando 3 teléfonos, si no tienen niguno
        for (
          let i = this.infoCrediticia.personaDto.datosContacto.telefonos.length;
          i < 3;
          i++
        ) {
          this.infoCrediticia.personaDto.datosContacto.telefonos.push({
            prefijo: "",
            numero: "",
            interno: "",
            horario: "",
            comentarios: "",
            contactosPositivos: 0,
            contactos: 0,
            perteneceA: { id: 1 },
            esCelular: true,
            esLaboral: false,
            anulado: false,
            //orden: ultimoOrden + 1
            orden: i + 1,
          });

          if (i == 0)
            this.infoCrediticia.personaDto.datosContacto.telefonos[
              i
            ].perteneceA = { id: 1 };
          else if (i == 1)
            this.infoCrediticia.personaDto.datosContacto.telefonos[
              i
            ].perteneceA = { id: 2 };
          else
            this.infoCrediticia.personaDto.datosContacto.telefonos[
              i
            ].perteneceA = { id: 3 };
        }
        await this.setPoliticaComercial();
        await this.loadConsultasAprobadas();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingProgress = false;
    },
    async cancelar() {
      let res = true;
      if (this.consultarVisible) {
        res = await this.$dialog.confirm({
          text: "¿Confirmar la cancelación de la carga?",
          title: "Atención",
          persistent: true, // Parece que no funciona...
        });
      }

      if (!res) {
        return;
      } else {
        this.clear();
      }
    },
    async cerrarSaveResults() {
      if (this.$store.state.modoCargaRapidaComer) this.$router.push("/home");

      this.clear();
    },
    async clear() {
      this.infoCrediticia = null;
      this.legajoCheck = false;
      this.consultarVisible = true;
      this.cuentaDebitoAnses = false;
      this.ingresoPor = "documento";
      this.model = {
        personaId: null,
        empresaId: this.UiCustomUserSettings.empresaPredeterminadaId,
        canalVentaId: this.UiCustomUserSettings.canalVentaPredeterminadoId,
        personaDto: {
          tipoSexoId: 1,
          nombre: "",
          apellido: "",
          fechaNacimiento: this.$moment(new Date()).format("YYYY-MM-DD"),
          tipoSituacionLaboralId: 1,
          empleo: {
            tipoSituacionLaboralId: 1,
            tipoSituacionLaboralActividadId: 0,
          },
          domicilios: [{}],
          datosContacto: { telefonos: [] },
        },
        trabaja: "false",
        ingresoMensual: 0,
        calificacionPersonaId: 0,
        planId: 0,
        politicaComercialId: 0,
        seAutorizoPorExcepcion: false,
        usuarioQueAutorizo: "",
        motivoAutorizacion: "",
        capital: 0,
        importeCuota: 0,
        importeCuotaMaxima: 0,
        cuotas: 0,
        diaCobroId: 0,
        showAgregarDocumentacion: true,
        consultaCredito: { estado: "" },
        cbu: "",
        modificaOferta: false,
        motivoModificacionOferta: "",
        montoRenovacion: 0,
        montoRetencion: 0,
        montoRenovacionAsignado: false,
        montoRetencionAsignado: false,
        cuentaDebito: {},
        solicitaDebito: false,
        tipoMedioPagoId: 1,
        tipoFormaLlegadaId: 1,
        tipoMotivoSolicitudId: 1,
        fechaCarga: this.$moment(new Date()).format("YYYY-MM-DD"),
        solicitaDebitoATarjeta: false,
        tarjetaDebito: {},
      };

      this.listConsultasAprobadas = [];
      this.archivosASubirDocumentacion = [];
      this.archivosASubirLegajo = [];

      this.step = 1;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales"); // traigo todas
        this.listSituacionesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSexo() {
      this.loading = true;
      try {
        var result = await http.get("tipossexo"); // traigo todas
        this.listSexos = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposdiacobro"); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMediosPago() {
      this.loading = true;
      try {
        var result = await http.get("tiposmediopagocredito"); // traigo todas
        this.listMediosPago = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormasLlegada() {
      this.loading = true;
      try {
        var result = await http.get("tiposformallegada"); // traigo todas
        this.listFormasLlegada = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDestinosCredito() {
      this.loading = true;
      try {
        var result = await http.get("tiposdestinocredito"); // traigo toda s
        this.listDestinosCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEntidadesFinancieras() {
      this.loading = true;
      try {
        var result = await http.get("entidadesfinancieras"); // traigo todas
        this.listEntidadesFinancieras = result.list;
        this.listEntidadesFinancieras.push({
          id: 0,
          codigo: "000",
          descripcion: "NO POSEE",
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadGruposComerciales() {
      this.loading = true;
      try {
        var result = await http.get("gruposcomerciales?limit=999"); // traigo todas
        this.listGruposComerciales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposModalidadesAltaConsulta() {
      this.loading = true;
      try {
        var result = await http.get("tiposmodalidadesaltaconsulta");

        this.listModalidadAltaConsulta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVentaHabilitados() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?soloActivos=true&usuarioId=" +
            this.user.id,
        ); // traigo todas
        this.listCanalesVentaHabilitados = result.list;

        // extraigo las empresas de los canales habilitados
        this.listEmpresas = Array.from(
          new Set(this.listCanalesVentaHabilitados.map((i) => i.empresaId)),
        ).map((id) => {
          return {
            id: id,
            nombre: this.listCanalesVentaHabilitados.find(
              (s) => s.empresaId === id,
            ).empresaDescripcion,
            color: this.listCanalesVentaHabilitados.find(
              (s) => s.empresaId === id,
            ).empresaColor,
          };
        });

        // selecciono la empresa predefinida del usuario
        if (this.UiCustomUserSettings.empresaPredeterminadaId > 0) {
          if (
            this.listEmpresas.find(
              (i) => i.id === this.UiCustomUserSettings.empresaPredeterminadaId,
            )
          ) {
            this.model.empresaId =
              this.UiCustomUserSettings.empresaPredeterminadaId;
          }
        }

        // selecciono el canal de venta predefinido del usuario
        if (this.UiCustomUserSettings.canalVentaPredeterminadoId > 0) {
          if (
            this.listCanalesVentaHabilitados.find(
              (i) =>
                i.id === this.UiCustomUserSettings.canalVentaPredeterminadoId,
            )
          ) {
            this.model.canalVentaId =
              this.UiCustomUserSettings.canalVentaPredeterminadoId;
          }
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    updateDatosTarjeta(datos) {
      Vue.$log.debug(datos);
      this.model.tarjetaDebito = datos;
      this.model.tarjetaDebito.altaTarjeta = true;
    },
    async validarTelefono() {
      if (!this.celular) {
        this.alertWarning("Debe ingresar el número de teléfono a validar.");
        return;
      }

      this.validando = true;
      try {
        var result = await http.get(
          "BusinessCore/validartelefonobasegeografica" +
            "?telefono=" +
            this.celular,
        );

        if (result.esValido) {
          this.celularValidado = result.esValido;
          this.celular = result.numeroFormateado;
        }
        this.resultadoValidacion = result;
      } catch (error) {
        // Error
        this.alertError(error);
        Vue.$log.error(error);
      }
      this.validando = false;
    },
    async validarMontoCuotas() {
      console.log(this.model.personaId);
      console.log(this.model.importeCuota);

      if (this.model.cuotas <= 0) {
        this.alertWarning("Debe ingresar un número de cuotas válido.");
        return;
      }

      this.loading = true;

      try {
        var result = await http.post("creditos/validarmontocuotas", {
          solicitud: {
            personaId: this.model.personaId,
            importeCuota: this.model.importeCuota,
          },
        });

        console.log(result);
        this.nextStep(3);
      } catch (error) {
        this.alertError(error);
      }
      this.loading = false;
    },

    /* async imprimirSolicitud(){

        for(var i = 0; i < this.selectedFormularios.length; i++)
        {
            Vue.$log.debug(this.selectedFormularios[i].nombreFormulario);
            let formulario = this.selectedFormularios[i].nombreFormulario;
            let params = [];
            //Vue.$log.debug(this.creditoId);
            params.push({"CreditoId": this.creditoId})

            await this.setReporteActivo({reporte: formulario, params:params})
            window.open('/report-viewer');
        }
    } */
  },
};
</script>
